import React from "react";
import { Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";
import ExpensesViewModal from "./ExpensesViewModal";
import { PulseLoader } from "react-spinners";

const Expenses = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AllExpenses,
    isLoading,
  } = ExpensesViewModal();
  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Expenses</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Expenses</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Expenses</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to="/user/admin/expenses/add"
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {isLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>#</th>
                            <th>Type</th>
                            <th>Expense Source</th>
                            <th>Amount</th> <th>Date</th>
                            <th className="text-end">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {AllExpenses?.length > 0 &&
                            AllExpenses.map((expense, i) => {
                              return (
                                <tr key={expense.id}>
                                  <td>{i + 1}</td>
                                  <td>
                                    <h2 className="text-capitalize">
                                      <a>{expense.ExpenseType}</a>
                                    </h2>
                                  </td>

                                  <td>{expense.ExpensePurchaseSource}</td>
                                  <td>{expense.ExpenseAmount} Rs</td>
                                  <td>{expense.Date}</td>

                                  <td className="text-end actions">
                                    <Link
                                      className="btn btn-sm bg-success-light me-2 "
                                      to={`/user/admin/expenses/update?id=${expense.id}`}
                                    >
                                      <Edit size={18} />
                                    </Link>
                                    <a
                                      className="btn btn-sm bg-success-light me-2 "
                                      onClick={() => {
                                        handleOpenDeleteDialog(expense.id);
                                      }}
                                    >
                                      <Trash2 size={18} />
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {AllExpenses?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this Expense?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default Expenses;
